const config = require("../config")
const url = config.base_dev_url + "container_farm_work_arrange"

module.exports = {
    getComposite: {
        url: url + "/getComposite",
        type: "get",
    },
    saveComposite: {
        url: url + "/saveComposite",
        type: "post",
    },
    toggleFollow: {
        url: url + "/toggleFollow",
        type: "get",
    },
    getArrangeDetail: {
        url: url + "/get",
        type: "get",
    },
}